import { Routes } from '@angular/router';
import { AppShellComponent } from './layout/app-shell.component';
import { InboxComponent } from './inbox/inbox.component';
import { LeadsPageComponent } from './pages/leads/leads-page.component';
import { OrdersPageComponent } from './pages/orders/orders-page.component';
import { InventoryPageComponent } from './pages/inventory/inventory-page.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard-page.component';
import { ProfilePageComponent } from './pages/profile/profile-page.component';
import { LoginPageComponent } from './pages/auth/login-page.component';
import { PasswordResetPageComponent } from './pages/auth/password-reset-page.component';
import { authGuard } from './shared/auth.guard';

export const routes: Routes = [
  // Default: go to login
  { path: '', pathMatch: 'full', redirectTo: 'login' },

  // Public route
  { path: 'login', component: LoginPageComponent },
  { path: 'reset-password', component: PasswordResetPageComponent },
  { path: 'set-password', component: PasswordResetPageComponent },

  // Protected app shell
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      // When inside the app, default to dashboard
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      { path: 'inbox', component: InboxComponent },
      { path: 'leads', component: LeadsPageComponent },
      { path: 'orders', component: OrdersPageComponent },
      { path: 'inventory', component: InventoryPageComponent },
      { path: 'dashboard', component: DashboardPageComponent },
      { path: 'profile', component: ProfilePageComponent },
    ],
  },

  // Fallback
  { path: '**', redirectTo: 'login' }
];
